import { gql } from 'graphql-request'

export const QueryBlockBlogTop = gql`
  fragment FragmentBlockBlogTop on BlockBlogTopModelRecord {
    __typename
    id
    topTitle: title
    topDescription: description
    articleHighlight {
      id
      title
      articlePublishedDate
      description
      slug
      image {
        width
        height
        url
        title
        responsiveImage {
          srcSet
          sizes
          src
          width
          height
          aspectRatio
          alt
          title
          bgColor
          base64
        }
      }
      video {
        ...QueryVideo
      }
      categories {
        id
        name
        slug
      }
      enabledLocales
      enabledMarkets {
        id
        title
        slugPrefix
      }
    }
  }
`
export const BlockBlogTop = {
  __typename: 'BlockBlogTop',
  fragmentName: 'FragmentBlockBlogTop',
  fragmentQuery: QueryBlockBlogTop,
  fragments: ['QueryVideo']
}
